import { RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType } from '../baseHelper';
import { InvitationDto } from '@api/models/invitation/InvitationDto';
import { QcsError } from '@api/models/QcsError';

interface TourniquetIdentity {
  pin?: string;
  /** Invitations the visitor may enter on. */
  invitations?: InvitationDto[];
  /** The one they picked, once there is a pick to make. */
  invitation?: InvitationDto;
  playground?: boolean;
  employeeId?: string;
  validationErrors?: QcsError[];
}

type State = BaseType<TourniquetIdentity>;

const initialState: State = {
  state: FetchState.None,
  data: {},
};

export const tourniquetIdentitySlice = baseSlice({
  name: 'tourniquetIdentity',
  initialState,
});

export const selectTourniquetIdentity = (state: RootState) => state.tourniquetIdentity.data;
export const tourniquetIdentityActions = tourniquetIdentitySlice.actions;
